'use strict';

var react = require('react');

var d=(t,u,e=!0)=>{function n(r){if(t?.current&&!t?.current?.contains(r.target)&&e)return u(r)}typeof document>"u"||react.useEffect(()=>(e?document?.addEventListener("mousedown",n):document?.removeEventListener("mousedown",n),()=>{document?.removeEventListener("mousedown",n);}),[e]);};

exports.a = d;
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-U3QVHVVZ.js.map